import { Button, type ButtonProps } from "@/components/ui/button";
import { useExploreDemo } from "@/hooks/useExploreDemo";
import { useT } from "@/lib/translation";

export function DemoPortfolioButton({
  label,
  stayOnPage = false,
  variant = "default",
  className,
}: {
  label?: string;
  stayOnPage?: boolean;
  variant?: ButtonProps["variant"];
  className?: string;
}) {
  const t = useT();
  const { handleExploreDemo, isDemoLoading } = useExploreDemo({ stayOnPage });
  return (
    <Button
      variant={variant}
      className={className}
      disabled={isDemoLoading}
      onClick={handleExploreDemo}
    >
      {isDemoLoading
        ? t("common:demoPortfolioButton.loading")
        : (label ?? t("common:demoPortfolioButton.label"))}
    </Button>
  );
}
